import React, { Suspense } from 'react';
import CircularProgress from '../../../components/CircularProgress';

const AdditionalServiceDetail = React.lazy(() => import('../components/AdditionalServiceDetail'));
function AdditionalServiceDetailView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <AdditionalServiceDetail {...props} />
    </Suspense>
  );
}

export default AdditionalServiceDetailView;
